import { DeleteRounded } from '@mui/icons-material';
import { Card, CardActions, CardContent, Grid, IconButton, List, ListItem, ListItemText } from '@mui/material';

interface ListingCardsProps {
  cards: any[],
  fields: any[],
  onCardClick: (e: { [key: string]: string }) => void
};

function ListingCards({ cards, fields, onCardClick }: ListingCardsProps ){

  // List action buttons
  let actions: any[];

  // Separate normal fields from actions
  fields = fields.filter((el: any) => {
    if(el.type !== 'actions')
      return true;
    else
      actions = el.getActions();
      return false;
  });

  const getFieldData = (fieldValue: any, card: any, column: any) => {

    if(typeof column.valueGetter === 'function'){
      fieldValue = column.valueGetter({ value: fieldValue, row: card });
    };

    if(typeof column.valueFormatter == 'function'){
      fieldValue = column.valueFormatter(fieldValue, card);
    };

    if(typeof column.renderCell == 'function'){
      fieldValue = column.renderCell({ value: fieldValue, row: card });
      return fieldValue;
    }
    else{
      return fieldValue ? String(fieldValue) : '';
    }
  };

  return(
    <Grid container spacing={2}>
      {cards.map((card: any, i: number) => (
        <Grid item xs={12} md={6} lg={4} xl={3} key={i}>
          <Card variant='outlined' sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
            <CardContent sx={{ padding: 0 }}>
              <List dense>
                {fields.map((el: any, i: number) => {
                  const fieldData = getFieldData(card[el.field], card, el);

                  return(
                    <ListItem key={i} onClick={() => { if(onCardClick) onCardClick({ row: card })}}>
                      <ListItemText primary={el.headerName} secondary={fieldData} />
                    </ListItem>
                  );
                })}
              </List>
            </CardContent>
            {actions &&
              <CardActions sx={{ backgroundColor: '#f8f8fa' }}>
                {actions.map((el: any, i: number) => (
                  <IconButton size='small' key={i} onClick={el.props.onClick}>
                    <DeleteRounded/>
                  </IconButton>
                ))}
              </CardActions>
            }
          </Card>
        </Grid>
      ))}
    </Grid>
  )
};
export default ListingCards;